// ==============================|| OVERRIDES - DIALOG ACTIONS ||============================== //

export default function DialogActions(theme) {
    return {
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    '& > :not(style) ~ :not(style)': {
                        marginLeft: 0,
                    },
                    justifyContent: 'center',
                    gap: '1rem',
                    paddingBottom: '2rem',
                    flexWrap: 'wrap',
                },
            }
        }
    };
}
